module.exports = __webpack_public_path__ + "static/media/toucan.c618105f.svg";